export default __webpack_public_path__ + "static/media/2.0d4a6199.webp";